import { c as _c } from "react/compiler-runtime";
import { useHostType } from '@repo/host/hooks/use-host-info';
import { getHost } from '@repo/host/host';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectExternalMapId, selectMapData, selectMapSubcategories, selectPlayerLocationDeltas, selectSelectedMarkerId } from '@repo/store/maps/slices/mapData';
import { HostType } from '@repo/types/host';
import type { MapDataLocationFeature, MapNavigationContext } from '@repo/types/maps/map-types';
import { useEffect, useMemo, useRef } from 'react';
function getSelectedPinName(pin: MapDataLocationFeature, subcategoryTitle?: string): string {
  return pin.properties.title || subcategoryTitle || pin.properties.externalId;
}
export function useOverlayMapContextSync() {
  const $ = _c(19);
  const hostType = useHostType();
  const mapExternalId = useAppSelector(selectExternalMapId);
  const mapData = useAppSelector(selectMapData);
  const subcategories = useAppSelector(selectMapSubcategories);
  const selectedMarkerId = useAppSelector(selectSelectedMarkerId);
  const playerLocationDeltas = useAppSelector(selectPlayerLocationDeltas);
  const lastSentRef = useRef(null);
  let t0;
  if ($[0] !== mapData || $[1] !== selectedMarkerId || $[2] !== subcategories) {
    bb0: {
      if (!selectedMarkerId || !mapData) {
        t0 = null;
        break bb0;
      }
      let t1;
      if ($[4] !== selectedMarkerId) {
        t1 = feature => feature.properties.externalId === selectedMarkerId;
        $[4] = selectedMarkerId;
        $[5] = t1;
      } else {
        t1 = $[5];
      }
      const pin = mapData.geojson.features.find(t1);
      if (!pin) {
        t0 = null;
        break bb0;
      }
      const subcategoryTitle = subcategories?.find(subcategory => subcategory.externalId === pin.properties.subcategoryExternalId)?.title;
      const [lng, lat] = pin.geometry.coordinates;
      let t2;
      if ($[6] !== lat || $[7] !== lng) {
        t2 = {
          lng,
          lat
        };
        $[6] = lat;
        $[7] = lng;
        $[8] = t2;
      } else {
        t2 = $[8];
      }
      t0 = {
        externalId: pin.properties.externalId,
        name: getSelectedPinName(pin, subcategoryTitle),
        lngLat: t2,
        gameCoords: pin.properties.gameCoords ?? null
      };
    }
    $[0] = mapData;
    $[1] = selectedMarkerId;
    $[2] = subcategories;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const selectedPin = t0;
  let t1;
  if ($[9] !== hostType || $[10] !== mapExternalId || $[11] !== playerLocationDeltas?.deltas || $[12] !== selectedPin) {
    t1 = () => {
      if (hostType !== HostType.OVERLAY) {
        return;
      }
      const context = {
        mapExternalId: mapExternalId ?? null,
        gameCoordinateDeltas: playerLocationDeltas?.deltas ?? null,
        selectedPin
      };
      const serialized = JSON.stringify(context);
      if (serialized === lastSentRef.current) {
        return;
      }
      lastSentRef.current = serialized;
      getHost().notifyMapNavigationContextChanged(context);
    };
    $[9] = hostType;
    $[10] = mapExternalId;
    $[11] = playerLocationDeltas?.deltas;
    $[12] = selectedPin;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== hostType || $[15] !== mapExternalId || $[16] !== playerLocationDeltas || $[17] !== selectedPin) {
    t2 = [hostType, mapExternalId, playerLocationDeltas, selectedPin];
    $[14] = hostType;
    $[15] = mapExternalId;
    $[16] = playerLocationDeltas;
    $[17] = selectedPin;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  useEffect(t1, t2);
}